import { render, staticRenderFns } from "./MailingView.vue?vue&type=template&id=4b79ba7c&scoped=true&"
import script from "./MailingView.vue?vue&type=script&lang=js&"
export * from "./MailingView.vue?vue&type=script&lang=js&"
import style0 from "./MailingView.vue?vue&type=style&index=0&id=4b79ba7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b79ba7c",
  null
  
)

export default component.exports